import { ProcessGeneral } from 'api/endpoints/processes';

export function hasMaintenancePayablesLicense(draft?: ProcessGeneral) {
  return draft?._links?.['searchMaintenancePayablesScenarios'] !== undefined;
}

const TEXTS = {
  PO_NUMBER_FIELD_NAME: 'poNumber',
  TOTAL_AMOUNT_FIELD_NAME: 'totalAmt',
  PO_DATE_FIELD_NAME: 'opened',
  VENDOR_FIELD_NAME: 'vendor',
  TOTAL_RECEIVED_RECEIPTS_FIELD_NAME: 'totalReceivedReceipts',
  SHOP_ID_FIELD_NAME: 'shopId',
  PAY_METHOD_FIELD_NAME: 'payMethod',
  ORDER_ID_FIELD_NAME: 'orderId',
  TOTAL_INVOICED_AMOUNT_FIELD_NAME: 'totalInvoicedAmount',
};

export { TEXTS };
